var cov_oz6nuzm1j = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/BoxOption.tsx",
      hash = "9e79c846accec8804283016773dd977ec6e0c418",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/BoxOption.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 16
        }
      },
      "1": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 50
        }
      },
      "2": {
        start: {
          line: 17,
          column: 50
        },
        end: {
          line: 17,
          column: 60
        }
      },
      "3": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "4": {
        start: {
          line: 19,
          column: 33
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "5": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 22
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "7": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 26,
          column: 11
        }
      },
      "8": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 25
        }
      },
      "9": {
        start: {
          line: 30,
          column: 72
        },
        end: {
          line: 30,
          column: 82
        }
      },
      "10": {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 62
        }
      },
      "11": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 69
        }
      },
      "12": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 34,
          column: 45
        }
      },
      "13": {
        start: {
          line: 36,
          column: 19
        },
        end: {
          line: 36,
          column: 35
        }
      },
      "14": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 65
        }
      },
      "15": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 43
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 16
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 15
          },
          end: {
            line: 24,
            column: 16
          }
        },
        loc: {
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 26,
            column: 5
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 29
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 39
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 39
          }
        }],
        line: 19
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 19
          }
        }, {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 31
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 18
          },
          end: {
            line: 33,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 32
          },
          end: {
            line: 33,
            column: 41
          }
        }, {
          start: {
            line: 33,
            column: 44
          },
          end: {
            line: 33,
            column: 69
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 18
          },
          end: {
            line: 34,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 29
          },
          end: {
            line: 34,
            column: 37
          }
        }, {
          start: {
            line: 34,
            column: 40
          },
          end: {
            line: 34,
            column: 45
          }
        }],
        line: 34
      },
      "4": {
        loc: {
          start: {
            line: 37,
            column: 18
          },
          end: {
            line: 37,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 47
          },
          end: {
            line: 37,
            column: 53
          }
        }, {
          start: {
            line: 37,
            column: 56
          },
          end: {
            line: 37,
            column: 65
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Select/BoxOption.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Checkbox from '../Checkbox/Checkbox';
import Radio from '../Radio/Radio';
import { selectClass } from './styles';
import { getDirectionClass } from '../utils/classname';

var BoxOption =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BoxOption, _PureComponent);

  var _super = _createSuper2(BoxOption);

  function BoxOption(props) {
    var _this;

    _classCallCheck(this, BoxOption);

    cov_oz6nuzm1j.f[0]++;
    cov_oz6nuzm1j.s[0]++;
    _this = _super.call(this, props);
    _this.locked = void 0;
    cov_oz6nuzm1j.s[1]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BoxOption, [{
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      cov_oz6nuzm1j.f[1]++;

      var _ref = (cov_oz6nuzm1j.s[2]++, this.props),
          data = _ref.data,
          onClick = _ref.onClick,
          isActive = _ref.isActive,
          disabled = _ref.disabled;

      cov_oz6nuzm1j.s[3]++;

      if ((cov_oz6nuzm1j.b[1][0]++, this.locked) || (cov_oz6nuzm1j.b[1][1]++, disabled)) {
        cov_oz6nuzm1j.b[0][0]++;
        cov_oz6nuzm1j.s[4]++;
        return;
      } else {
        cov_oz6nuzm1j.b[0][1]++;
      }

      cov_oz6nuzm1j.s[5]++;
      this.locked = true;
      cov_oz6nuzm1j.s[6]++;
      onClick(!isActive, data);
      cov_oz6nuzm1j.s[7]++;
      setTimeout(function () {
        cov_oz6nuzm1j.f[2]++;
        cov_oz6nuzm1j.s[8]++;
        _this2.locked = false;
      }, 200);
    }
  }, {
    key: "render",
    value: function render() {
      cov_oz6nuzm1j.f[3]++;

      var _ref2 = (cov_oz6nuzm1j.s[9]++, this.props),
          data = _ref2.data,
          isActive = _ref2.isActive,
          renderItem = _ref2.renderItem,
          columns = _ref2.columns,
          multiple = _ref2.multiple,
          disabled = _ref2.disabled;

      var className = (cov_oz6nuzm1j.s[10]++, selectClass(getDirectionClass('option')));
      var width = (cov_oz6nuzm1j.s[11]++, columns < 0 ? (cov_oz6nuzm1j.b[2][0]++, undefined) : (cov_oz6nuzm1j.b[2][1]++, "".concat(1 / columns * 100, "%")));
      var Input = (cov_oz6nuzm1j.s[12]++, multiple ? (cov_oz6nuzm1j.b[3][0]++, Checkbox) : (cov_oz6nuzm1j.b[3][1]++, Radio));
      var result = (cov_oz6nuzm1j.s[13]++, renderItem(data));
      var title = (cov_oz6nuzm1j.s[14]++, typeof result === 'string' ? (cov_oz6nuzm1j.b[4][0]++, result) : (cov_oz6nuzm1j.b[4][1]++, undefined));
      cov_oz6nuzm1j.s[15]++;
      return (
        /*#__PURE__*/
        React.createElement(Input, {
          disabled: disabled,
          style: {
            width: width
          },
          checked: isActive,
          className: className,
          onChange: this.handleClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          title: title,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 41,
            columnNumber: 9
          }
        }, result))
      );
    }
  }]);

  return BoxOption;
}(PureComponent);

export default BoxOption;